import constants from "../constants";

const ExtraPesFields = {
  sections: [
    {
      sectionId: "1",
      subsectionId: null,
      fields: [
        {
          class: "",
          containerClass: "",
          default: "",
          id: constants.INPUT_ID_PES_NUMBER,
          label: "Presencia Económica Significativa (PES) number",
          labelEn: "",
          labelClass: "",
          labelDescription: "",
          name: constants.INPUT_ID_PES_NUMBER,
          placeHolder: "Enter your PES Number",
          required: true,
          type: constants.INPUT_TYPE_TEXT,
          customHandler: constants.INPUT_HANDLER_ONLY_NUMBERS,
          validators: [
            {
              type: constants.VALIDATOR_NOT_EMPTY,
              errorMessage: "Enter a valid PES number."
            },
            {
              type: constants.VALIDATOR_MAX_LENGTH,
              errorMessage: "PES number must not exceed 10 digits.",
              data: {
                maxLength: 10
              }
            },
            {
              type: constants.VALIDATOR_MIN_LENGTH,
              errorMessage: "PES number must be at least 9 digits long.",
              data: {
                minLength: 9
              }
            }
          ]
        },
        {
          class: "",
          containerClass: "",
          dataSource: "",
          id: constants.INPUT_ID_PES_DOCUMENT_FILE,
          label: "Presencia Económica Significativa (PES) document",
          labelEn: "Presencia Económica Significativa (PES) document",
          labelDescription: "",
          labelClass: "",
          boxDescription: "1 JPG, PNG or PDF file allowed.",
          name: constants.INPUT_ID_PES_DOCUMENT_FILE,
          type: constants.INPUT_TYPE_FILE,
          required: true,
          attachTextButton: "Attach",
          attachTextLabel: "or drag the file",
          dropTextMessage: "Drop the file into this area",
          accept: ".jpg,.jpeg,.png,.pdf",
          validators: [
            {
              type: constants.VALIDATOR_FILE_SIZE,
              errorMessage: "The file exceeds the allowed limit, it must not exceed 3MB.",
              data: {
                maxAllowedSize: 3e6
              }
            },
            {
              type: constants.VALIDATOR_FILE_TYPE,
              errorMessage: "Invalid file, attach only JPG, PNG or PDF.",
              data: {
                allowedFileTypes: ["jpg", "jpeg", "png", "pdf"]
              }
            },
            {
              type: constants.VALIDATOR_HAS_CURRENT_VALUE,
              errorMessage:
                "You can only upload one file. If you want to attach a different file, you'll need to delete the current one."
            },
            {
              type: constants.VALIDATOR_NOT_EMPTY,
              errorMessage: "Please attach a PES Document file."
            }
          ]
        },
        {
          class: "cb_checkbox",
          containerClass: "",
          id: constants.INPUT_ID_FACO_CERTIFY_INFO,
          labelClass: "",
          labelMandatory: "",
          labelDescription: "",
          name: constants.INPUT_ID_FACO_CERTIFY_INFO,
          value: constants.SI,
          required: true,
          placeHolder: "I certify that the information provided is true and accurate.",
          type: constants.INPUT_TYPE_CHECKBOX,
          validators: [
            {
              type: constants.VALIDATOR_IS_CHECKED,
              errorMessage: "You must accept to continue."
            }
          ]
        }
      ]
    }
  ]
};

export default ExtraPesFields;
